import React, { Component } from 'react';
import { Modal, Table, Button, Tabs, Tab } from 'react-bootstrap';
import SystemInformationPanel from './SystemInformationPanel';

import './SettingsPopup.css';
import './Controls/MusterTableStyle.css';

//Admin editor for the settings table, opened from the gear in the top bar. Every row is
//listed with its value editable and a Save per row; settings can never be added or removed
//here, only their values changed. onSaved fires after a successful save so the owner can
//refresh anything derived from settings (e.g. the top bar's tab labels).
//Settings named here are on/off switches and render as a checkbox storing '1'/'0'.
export const BOOLEAN_SETTINGS = ['Confirm deletion'];

class SettingsPopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false,
            activeTab: 'settings',
            settings: [],
            loginImages: [],
            errMsg: ''
        };
    }

    show = () => {

        this.setState({ showPopup: true, activeTab: 'settings', errMsg: '' });

        fetch('login_appearance').then(res => res.json()).then(data => this.setState({ loginImages: Array.isArray(data.images) ? data.images : [] })).catch(() => this.setState({ loginImages: [] }));

        fetch('settings_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({
                settings: data,
                errMsg: ''
            });
        })
        .catch(() => this.setState({ errMsg: 'Settings could not be loaded. Please reopen the popup to try again.' }))
    }

    handleClose = () => {
        this.setState({ showPopup: false, errMsg: '' });
    }

    handleValueChange = (index) => (event) => {

        const settings = this.state.settings.slice();

        settings[index] = { ...settings[index], value: event.target.value };
        this.setState({ settings: settings });
    }

    handleSave = (index) => () => {

        const row = this.state.settings[index];

        fetch('settings_value_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "id=" + encodeURIComponent(row.id) + "&value=" + encodeURIComponent(row.value)
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && 'true' === data[0].success)
            {
                this.setState({ errMsg: row.setting + ' saved' });

                if (this.props.onSaved)
                {
                    this.props.onSaved();
                }
            }
            else
            {
                this.setState({ errMsg: (data && data[0] && data[0].msg) || 'Save failed' });
            }
        })
        .catch(() => {
            this.setState({ errMsg: 'Save failed - is the settings service deployed on this server?' });
        })
    }

    handleToggleChange = (index) => (event) => {

        const settings = this.state.settings.slice();

        settings[index] = { ...settings[index], value: event.target.checked ? '1' : '0' };
        this.setState({ settings: settings });
    }

    renderValueControl = (row, index) => {

        if (row.setting === 'Login background image') {
            return <div>
                <select className="settingValueInput" aria-label={row.setting} value={row.value} onChange={this.handleValueChange(index)}>
                    {!this.state.loginImages.includes(row.value) && <option value={row.value}>{row.value} (unavailable)</option>}
                    {this.state.loginImages.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
                {this.state.loginImages.includes(row.value) && <img src={'images/login/' + encodeURIComponent(row.value)} alt="Selected login background preview" style={{ display: 'block', width: '240px', maxWidth: '100%', height: '120px', objectFit: 'contain', marginTop: '8px', background: '#edf0f2' }} />}
            </div>;
        }
        if (BOOLEAN_SETTINGS.indexOf(row.setting) >= 0)
        {
            return (
                <input
                    className="settingValueCheckbox"
                    aria-label={row.setting}
                    type="checkbox"
                    checked={'1' === row.value}
                    onChange={this.handleToggleChange(index)}
                />
            );
        }

        return (
            <input
                className="settingValueInput"
                aria-label={row.setting}
                type="text"
                value={row.value}
                onChange={this.handleValueChange(index)}
            />
        );
    }

    renderRows = () => {
        return this.state.settings.map((row, index) => (
            <tr key={row.id}>
                <td className="settingName">{row.setting}</td>
                <td>
                    {this.renderValueControl(row, index)}
                </td>
                <td>
                    <Button size="sm" onClick={this.handleSave(index)}>Save</Button>
                </td>
            </tr>
        ));
    }

    render() {
        return (
            <Modal
              dialogClassName="settingsPopupModal"
              show={this.state.showPopup}
              onHide={this.handleClose}
              backdrop="static"
              centered
              aria-labelledby="settings-popup-title"
            >
            <Modal.Header closeButton>
                <Modal.Title id="settings-popup-title">Settings</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Tabs id="settings-popup-tabs" activeKey={this.state.activeTab}
                    onSelect={activeTab => this.setState({ activeTab })} mountOnEnter unmountOnExit>
                <Tab eventKey="settings" title="Settings">
                <div className="settingsTableScroll">
                <Table className="settingsTable musterStyleTable">
                <thead>
                    <tr>
                        <th><h3>Setting</h3></th>
                        <th><h3>Value</h3></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderRows()}
                </tbody>
                </Table>
                </div>
                </Tab>
                <Tab eventKey="system" title="System">
                    <SystemInformationPanel />
                </Tab>
                </Tabs>
            </Modal.Body>

            {this.state.activeTab === 'settings' && <Modal.Footer>
                <span className="settingsMsg">{this.state.errMsg}</span>
            </Modal.Footer>}
            </Modal>
        )
    }
}

export default SettingsPopup;
